"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BENEFIT_WIDTH = exports.BENEFITS_ROOT_THREE = exports.BENEFITS_ROOT_SIX = exports.BENEFITS_MOBILE_SLIDE = exports.BENEFITS_MAIN_TITLE = exports.BENEFITS_LAYOUT_NAME = exports.BENEFITS_CAROUSEL_ID = exports.BENEFITS_BOX_TITLE = exports.BENEFITS_BOX_TEXT = exports.BENEFITS_BOX_ICON = exports.BENEFITS_BOX = void 0;
const BENEFITS_LAYOUT_NAME = exports.BENEFITS_LAYOUT_NAME = 'EditorialBenefits';
const BENEFITS_CAROUSEL_ID = exports.BENEFITS_CAROUSEL_ID = 'benefits-carousel';
const BENEFITS_ROOT_THREE = exports.BENEFITS_ROOT_THREE = 'benefits-root-three';
const BENEFITS_ROOT_SIX = exports.BENEFITS_ROOT_SIX = 'benefits-root-six';
const BENEFITS_MAIN_TITLE = exports.BENEFITS_MAIN_TITLE = 'benefits-main-title';
const BENEFITS_BOX = exports.BENEFITS_BOX = 'benefits-box';
const BENEFITS_BOX_TITLE = exports.BENEFITS_BOX_TITLE = 'benefits-box-title';
const BENEFITS_BOX_TEXT = exports.BENEFITS_BOX_TEXT = 'benefits-box-text';
const BENEFITS_BOX_ICON = exports.BENEFITS_BOX_ICON = 'benefits-box-icon';
const BENEFITS_MOBILE_SLIDE = exports.BENEFITS_MOBILE_SLIDE = 'benefits-mobile-slide';
const BENEFIT_WIDTH = exports.BENEFIT_WIDTH = 290;
